document.addEventListener("DOMContentLoaded", function () {
    const menuDrawer = document.querySelector(".menu-drawer");
    const toggles = document.querySelectorAll(".js__megamenu");
    const backButtons = document.querySelectorAll('.submenu-back');
    const drawerContainer = document.querySelector(".menu-drawer-container");
    toggles.forEach(function (toggle) {
        toggle.addEventListener("click", function (e) {
            e.preventDefault();
               const menu = toggle.nextElementSibling;
                if (menu && menu.classList.contains("js__megamenu-inner")) {
                    menu.classList.toggle("hidden");
                }
            });
        });


    backButtons.forEach(function (back) {
        back.addEventListener("click", function () {
            const menu = back.closest(".js__megamenu-inner");
            menu?.classList.add("hidden");
        });
    });

    document.addEventListener("click", function (e) {
        if (!menuDrawer.contains(e.target) && drawerContainer.hasAttribute("open") ) {
            backButtons.forEach(function (back) {
                back.closest(".js__megamenu-inner").classList.add('hidden');
            });
        }
    });
})